export const VisionStatementMessages = {
  SUCCESS_SET_VISION: 'vision-statement.success-set-vision',
  SUCCESS_DELETE_VISION: 'vision-statement.success-delete-vision'
};
